import { Switch, Route,Redirect } from 'react-router-dom';
import './App.css';
import Servicios from './componets/Servicios';
import Nosotros from './componets/Nosotros';
import Navbar from './componets/Navbar';
import Footer from './componets/Footer';
import Header from './componets/Header';
import Paquetes from './componets/Paquetes';
import Vivencias from './componets/Vivencias';

function App() {
  return (
    <div className='font-poppins font-normal'>
      <Navbar/>
      <Switch>
        <Route exact path="/">
            <Redirect to="/Inicio" />
        </Route>
        <Route exact path="/Inicio">
          <Header/>
          <Servicios/>
          <Nosotros/>
          <Paquetes/>
          <Vivencias/>
        </Route>
        <Route exact path="/Servicios">
          <Servicios/>
        </Route>
        <Route exact path="/Nosotros">
          <Nosotros/>
        </Route>
        <Route exact path="/Paquetes">
          <Paquetes/>
        </Route>
        <Route exact path="/Vivencias">
          <Vivencias/>
        </Route>
      </Switch>
      <Footer/>
    </div>
  );
}

export default App;
